import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0a0b3dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-info" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "查看详情", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "product-item",
        key: item.id
      }, [
        _createElementVNode("img", {
          class: _normalizeClass(["cover", item % 2 !== 0 ? 'left' : 'right']),
          src: item.coverImage,
          alt: ""
        }, null, 10, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass(["content-info", item % 2 !== 0 ? 'right' : 'left'])
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.description), 1),
          _createElementVNode("div", {
            onClick: ($event: any) => (_ctx.handleGoDetail(item)),
            class: "btn"
          }, _hoisted_8, 8, _hoisted_5)
        ], 2)
      ]))
    }), 128))
  ]))
}